import { createContext, useContext } from 'react';
import {
  APP_SETTINGS_DEFAULTS,
  STORE_INFO_DEFAULTS,
  type AppSettings,
  type StoreInfo,
} from '@rosita/shared';

interface AppSettingsContextValue {
  settings: AppSettings;
  storeInfo: StoreInfo;
  loaded: boolean;
}

export const AppSettingsContext = createContext<AppSettingsContextValue>({
  settings: APP_SETTINGS_DEFAULTS,
  storeInfo: STORE_INFO_DEFAULTS,
  loaded: false,
});

export function useAppSettings(): AppSettings {
  return useContext(AppSettingsContext).settings;
}

export function useAppSettingsLoaded(): boolean {
  return useContext(AppSettingsContext).loaded;
}

/**
 * The seller's legal details (name, NIF, address, email, phone). Fields the
 * server could not resolve come back as empty strings — render each line only
 * when it has a value, never a placeholder.
 */
export function useStoreInfo(): StoreInfo {
  return useContext(AppSettingsContext).storeInfo;
}
